import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';

export class MethodComponent extends BaseModel {
  static get entity() {
    return 'method-components';
  }

  static get fk() {
    return 'method_component_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      content: this.attr(null),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      additional_resource: this.attr(null),
      reference: this.attr(null),
      attachments: this.attr([])
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get('/method-components', { params });
      },

      fetchById(id) {
        return this.get(`/method-components/${id}`);
      },

      create(body) {
        return this.post('/method-components', body);
      },

      update(id, body) {
        return this.put(`/method-components/${id}`, body);
      },

      markAsRead(id) {
        return this.post(`/method-components/${id}/progress`);
      },

      async countMethodComponents(learningUnitId, returnOnlyData = true) {
        const response = await this.get('/method-components/count', {
          params: { learning_unit: learningUnitId }
        });

        return MethodComponent._handleResponse(response, returnOnlyData);
      },

      async fetchMethodComponents(learningUnitId, returnOnlyData = true) {
        const response = await this.get(`/method-components/${learningUnitId}`, {
          params: { _populate: 'attachments' }
        });
        return MethodComponent._handleResponse(response, returnOnlyData);
      },

      async fetchMethodComponentsByLearningUnit(learningUnitId, returnOnlyData = true) {
        const response = await this.get('/method-components', {
          params: { learning_unit: learningUnitId }
        });
        return MethodComponent._handleResponse(response, returnOnlyData);
      },

      async createMethodComponent(data, returnOnlyData = true) {
        const response = await this.post('/method-components', data);
        return MethodComponent._handleResponse(response, returnOnlyData);
      },

      async updateMethodComponent(id, data, returnOnlyData = true) {
        const response = await this.put(`/method-components/${id}`, data);
        return MethodComponent._handleResponse(response, returnOnlyData);
      },

      async deleteMethodComponent(id, returnOnlyData = true) {
        const response = await this.delete(`/method-components/${id}`);
        return MethodComponent._handleResponse(response, returnOnlyData);
      }
    }
  };

  static _handleResponse(response, returnOnlyData) {
    const data = response.response?.data ?? response.data;
    return returnOnlyData ? data : response;
  }
}

export default MethodComponent;
